export const TRANSLATE_FIELD_QUIZZ_MAP = {
  description: "Descrição",
  title: "Título",
  time_limit_minutes: "Tempo limite",
  approval_average: "Média de aprovação",
  number_of_attempts: "Número de tentativas",
  release_at: "Data de liberação",
  questions: {
    title: "Título da Questão",
    answer_options: {
      title: "Título da alternativa"
    }
  }
};

export const TRANSLATE_FIELD_MEMBER_SETUP = {
  name: "Nome",
  description: "Descrição",
  link_sale_page: "Link da página de vendas",
  subdomain: "Subdomínio",
  domain: "Domínio próprio",
  logo: "Logo do produto",
  background: "Imagem de background",
  brand: "Logo do produto",
  showcase: "Link da página de vendas do curso",
  name_course: "Nome do Curso",
  hourly_load: "Carga horária",
  organizer_name: "Nome do organizador",
  image_signature: "Imagem da assinatura",
  certificate_background_image: "Imagem de background",
  certificate_enabled: "Habilitar certificado",
  password_default: "Password Padrão",
  minimum_content_progress: "Porcentagem de conclusão do curso",
  minimum_quiz_progress: "Porcentagem de conclusão para avaliação final",
  cover: "Capa",
  link_video: "Link do video",
  video_display: "Link do video em miniatura",
  cover_mobile: "Capa para mobile",
  link_video_mobile: "Video para mobile",
  placeholder_cover: "Capa placeholder",
  placeholder_lesson: "Capa placeholder da aula",
  placeholder_module: "Capa placeholder do módulo",
  placeholder_cover_mobile: "Capa placeholder mobile"
};

export const TRANSLATE_FIELD_PRICE_MAP = {
  name: "Nome",
  description: "Descrição",
  price: "Preço",
  currency: "Moeda",
  installments: "Parcelas",
  start_at: "Início da oferta",
  end_at: "Fim da oferta",
  order_bump: "Order Bump",
  sck: "Parâmetro SCK",
  expire_url: "URL para redirecionar após oferta expirar",
  stock: "Quantidade do estoque",
  stock_empty_url: "URL para redirecionar quando o estoque se esgotar"
};

export const TRANSLATE_FIELD_INTEGRATION_MAP = {
  product_id: "Produto",
  description: "Descrição",
  url: "URL",
  plan_id: "Plano",
  events: "Eventos Disparados",
  token: "Token",
  group_name: "Nome do grupo",
  telegram_config_code: "Código de configuração do telegram",
  chat_id: "ID do chat",
  events: "Eventos",
  name: "Nome"
};

export default {
  TRANSLATE_FIELD_QUIZZ_MAP,
  TRANSLATE_FIELD_MEMBER_SETUP,
  TRANSLATE_FIELD_PRICE_MAP,
  TRANSLATE_FIELD_INTEGRATION_MAP
};
